// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3412":"8b2ab630","4230":"8b2ab630","5041":"4933da0a","9240":"8fafdab5"}[chunkId] + ".chunk.css";
};